import styled, { css } from 'styled-components'

import { palette } from '../../../theme/palette'

export const RatingContainer = styled.div`
  padding: 0 10px 12px;
`

export const RatingList = styled.ul<{ isScoreType: boolean }>`
  margin: 0;
  padding: ${props => props.isScoreType ? 0 : '10px 0'};
  list-style-type: none;
  display: flex;
  justify-content: center;
  gap: 0 4px;
  border: ${props => props.isScoreType ? 'none' : `1px solid ${palette.lightGray}`};
  border-radius: 26px;
  
  ${props => props.isScoreType && css`
    flex-wrap: wrap;
    gap: 8px 4px;
  `}
`

export const StarsRatingItem = styled.li`
  
  &:last-child {
    margin-right: 0;
  }
`

export const StarsRatingButton = styled.button<{ isDisabled: boolean }>`
  background-color: ${palette.transparent};
  border: none;
  cursor: ${props => props.isDisabled ? 'auto' : 'pointer'};
  display: block;
  
  & svg {
    display: block;
  }
`

export const ScoresRatingItem = styled(StarsRatingItem)`

`

export const ScoresRatingButton = styled(StarsRatingButton)<{ isSelected: boolean }>`
  width: 40px;
  height: 44px;
  border: 1px solid ${props => props.isDisabled ? palette.disabledElement : palette.mainBlue};
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  cursor: ${props => props.isDisabled ? 'auto' : 'pointer'};
  color: ${props => props.isDisabled ? palette.mediumGray : props.isSelected ? palette.white : palette.mainBlue};
  background-color: ${props => props.isSelected ? props.isDisabled ? palette.disabledElement : palette.mainBlue : palette.white};
`
